import { Center, Container, Paper, Stack, Text, Title } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { httpDelete } from "shared/api/httpClient";
import { CenteredBryxLoader } from "shared/components/global/Loaders/BryxLoader";
import { runAsync } from "shared/utils/fns";

const Page = () => {
    const { id } = Route.useParams();
    const unsubscribe = useMutation({ mutationFn: () => httpDelete<{ value: string }>(`/unsubscribe/${id}`) });

    const [eudValue, setEudValue] = useState<string>();

    useEffect(() => {
        runAsync(async () => {
            const { value } = await unsubscribe.mutateAsync();
            setEudValue(value);
        });
    }, []);

    if (unsubscribe.isPending) return <CenteredBryxLoader />;

    if (!eudValue)
        return (
            <Center>
                <Title order={1}>Failed to find device</Title>
            </Center>
        );

    return (
        <Container h="100vh">
            <Stack h="100%" w="100%" align="center" justify="center" gap="xs">
                <Paper p="sm">
                    <Text fz="1.5rem" maw="100%" style={{ textWrap: "wrap" }} ff="monospace">
                        {eudValue}
                    </Text>
                </Paper>
                <Title order={1} component="p">
                    has been unsubscribed from alerts.
                </Title>
                <Text c="dimmed">You may close the page</Text>
            </Stack>
        </Container>
    );
};

/** @public */
export const Route = createFileRoute("/unsubscribe/$id")({
    component: Page,
});
